import { isAfter, isBefore } from 'date-fns';
import { useFormikContext } from 'formik';
import { useMemo } from 'react';

function useIsBefore(
  date: Date | string | null | undefined,
  otherDate: Date | string | null | undefined
) {
  return useMemo(() => {
    if (!date || !otherDate) return false;
    return isBefore(
      typeof date === 'string' ? new Date(date) : date,
      typeof otherDate === 'string' ? new Date(otherDate) : otherDate
    );
  }, [date, otherDate]);
}

function useIsAfter(
  date: Date | string | null | undefined,
  otherDate: Date | string | null | undefined
) {
  return useMemo(() => {
    if (!date || !otherDate) return false;
    return isAfter(
      typeof date === 'string' ? new Date(date) : date,
      typeof otherDate === 'string' ? new Date(otherDate) : otherDate
    );
  }, [date, otherDate]);
}

export function useIsInitiallyBefore(name: string, minBookingDate?: Date) {
  const { getFieldMeta } = useFormikContext<unknown>();
  const { initialValue } = getFieldMeta<Date | null>(name);

  return useIsBefore(initialValue, minBookingDate);
}

export function useIsInitiallyAfter(name: string, maxBookingDate?: Date) {
  const { getFieldMeta } = useFormikContext<unknown>();
  const { initialValue } = getFieldMeta<Date | null>(name);

  return useIsAfter(initialValue, maxBookingDate);
}
